import SectionHeading from "./SectionHeading";
import { Reveal } from "../shared/Reveal";
import FAQAccordion from "../shared/FAQAccordion";
import { FAQS } from "../../data/faqs";

export default function FAQ() {
  return (
    <section className="bg-background py-20 md:py-28 lg:py-36" data-testid="faq-section">
      <div className="container-psv grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-4 lg:sticky lg:top-32">
          <SectionHeading
            eyebrow="FAQ"
            heading="Questions patients ask"
            intro="Balanced, responsible answers. We do not provide individual medical advice — final recommendations come from a licensed medical professional."
          />
        </div>
        <div className="lg:col-span-8">
          <Reveal>
            <FAQAccordion faqs={FAQS} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
